module.exports = __webpack_public_path__ + "static/media/delimited_list_example.1785e7f3.png";